export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MobileMenu.vue?vue&type=template&id=42f5245a&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/MobileMenu.vue?vue&type=template&id=42f5245a&scoped=true
// module id = 89
// module chunks = 0